import { useState } from 'react';

import { Link } from 'react-router';

import { Chip } from '@cfa/react-core';

import { useSearchClickFeedback } from '../hooks';

import { AnswerSource } from '@/_generated/api-clients/xp';

const MAX_VISIBLE = 3;

interface SourcesProps {
  sources: AnswerSource[];
}

/** Sources chip list with overflow collapse. */
const Sources: React.FC<SourcesProps> = ({ sources }) => {
  const [expanded, setExpanded] = useState(false);
  const sendClickFeedback = useSearchClickFeedback();

  const citedSources = sources.filter(_ => _.cited);
  const visibleSources = expanded
    ? citedSources
    : citedSources.slice(0, MAX_VISIBLE);
  const hiddenCount = citedSources.length - MAX_VISIBLE;

  return (
    <>
      {visibleSources.map(source => (
        <Link
          key={source.name}
          to={`/doc/${source.documentId}`}
          target="_blank"
          onClick={() => sendClickFeedback(source)}
        >
          <Chip className="bg-base-0! hover:bg-base-2! border-brand-navy! text-brand-navy! transition-colors">
            {source.name}
          </Chip>
        </Link>
      ))}
      {!expanded && hiddenCount > 0 && (
        <button onClick={() => setExpanded(true)}>
          <Chip className="bg-base-0! hover:bg-base-2! border-brand-navy! text-brand-navy! cursor-pointer transition-colors">
            +{hiddenCount}
          </Chip>
        </button>
      )}
    </>
  );
};

export default Sources;
